import React, {useEffect} from 'react';
import { Link } from 'react-router-dom';
import WorkCard from '../components/WorkCard';
import BookButton from '../components/BookButton'
import worksData from '../assets/data.json';

const Works = () => {
  
  useEffect(() => {
    const savedPosition = sessionStorage.getItem('scrollPosition');
    if (savedPosition !== null) {
      window.scrollTo(0, parseInt(savedPosition));
      sessionStorage.removeItem('scrollPosition'); // clean up
    }
  }, []);

  return (
    <div>
      <div className="works-container">
        {worksData.slice(-9).reverse().map((work) => (
          <WorkCard
            key={work.id}
            workData={work}
            id={work.id}
          />
        ))}
      </div>

      <div className="older-works-container">
        {worksData.slice(0, worksData.length - 9).reverse().map((work) => (
          <div className='work-item-box'>
            <Link to={`/works/${work.id}`} className="work-item" onClick={() => sessionStorage.setItem('scrollPosition', window.scrollY)}>

              <h1 className='work-item-title'>{work.title} <span className='work-item-span'>{work.format}</span></h1>
            </Link>
          </div>
        ))}
      </div>

      <div className="section-separator"></div>

      <div className='more-work-section'>
        <div className="more-title-work">
          <h1>IDEAS...</h1>
        </div>
        <div className="more-text-work">
          <h1>GOT A PROJECT?</h1>
          <h3>LET'S LEARN MORE ABOUT IT!</h3>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <BookButton />
          </div>
        </div>
      </div>

    </div>
  );
};

export default Works;